import axios from "axios";

export const paymentService = {
  requestPayment,
  requestPaymentBilling,
  getPayment,
  requestCreditPayment,
  initiateCreditPayment,
  requestPayCodePayment,
  initiatePayCodePayment,
  getPaymentCredit
};

async function requestPayment(amount, id, isFullDebt, paymentType) {
  return await axios({
    url: process.env.VUE_APP_API_URL + "payment/request-payment",
    method: "POST",
    data: {
      amount: amount,
      account: id,
      isFullDebt: isFullDebt,
      paymentType: paymentType
    }
  });
}

async function requestPaymentBilling(
  amount,
  id,
  billReference,
  paymentAccount,
  paymentType
) {
  return axios({
    url: process.env.VUE_APP_API_URL + "payment/request-payment-billing",
    method: "POST",
    data: {
      amount: amount,
      account: id,
      billReference: billReference,
      paymentAccount: paymentAccount,
      paymentType: paymentType
    }
  });
}

async function requestCreditPayment(reference) {
  return axios({
    url: process.env.VUE_APP_API_URL + "payment/request-credit-payment",
    method: "POST",
    data: {
      reference: reference
    }
  });
}

async function initiateCreditPayment(reference, verifier, amount, paymentType) {
  return axios({
    url: process.env.VUE_APP_API_URL + "payment/initiate-credit-payment",
    method: "POST",
    data: {
      reference: reference,
      verifier: verifier,
      amount: amount,
      paymentType: paymentType
    }
  });
}

async function requestPayCodePayment(code) {
  return axios({
    url: process.env.VUE_APP_API_URL + "payment/request-prepay-code-payment",
    method: "POST",
    data: {
      code: code
    }
  });
}

async function initiatePayCodePayment(code, verifier, amount, paymentType) {
  return axios({
    url: process.env.VUE_APP_API_URL + "payment/initiate-prepay-code-payment",
    method: "POST",
    data: {
      code: code,
      verifier: verifier,
      amount: amount,
      paymentType: paymentType
    }
  });
}

async function getPayment(reference) {
  return await axios({
    url: process.env.VUE_APP_API_URL + "payment/get-request",
    method: "POST",
    data: { reference: reference }
  });
}

async function getPaymentCredit(reference) {
  return await axios({
    url: process.env.VUE_APP_API_URL + "payment/get-credit-request",
    method: "POST",
    data: { reference: reference }
  });
}
